import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell, PlaceholderCard } from "@/components/DashboardShell";
import { SUPER_ADMIN_NAV } from "@/lib/nav";

export const Route = createFileRoute("/_authenticated/super-admin/verifications")({
  head: () => ({
    meta: [
      { title: "Verification management · Landoo Super Admin" },
      { name: "description", content: "Verification management — Landoo super admin console." },
    ],
  }),
  component: () => (
    <DashboardShell title="Verification management" role="Super Admin" items={SUPER_ADMIN_NAV}>
      <PlaceholderCard
        title="Verification management"
        description="Super admin management surface for Verification management."
      />
    </DashboardShell>
  ),
});
